/**
 * Quantity display for MoySklad накладные. Quantities travel as INT
 * milli-units (qty × 1000) — same "integers only" rule as money (SPEC §2).
 */

/** 1500 → "1,5"; 12000 → "12"; 333 → "0,333" (Russian decimal comma). */
export function formatQuantityMilli(quantityMilli: number): string {
  if (!Number.isSafeInteger(quantityMilli)) throw new Error(`Invalid quantity: ${quantityMilli}`);
  const sign = quantityMilli < 0 ? '-' : '';
  const abs = Math.abs(quantityMilli);
  const whole = Math.trunc(abs / 1000);
  const frac = String(abs % 1000).padStart(3, '0').replace(/0+$/, '');
  return frac === '' ? `${sign}${whole}` : `${sign}${whole},${frac}`;
}

/** True when {@link qtyToMilli} would accept the string (≤3 decimals, > 0 ok). */
export function isValidQtyInput(input: string): boolean {
  const normalized = input.replace(/\s/g, '').replace(',', '.');
  return /^\d+(?:\.\d{1,3})?$/.test(normalized);
}

/** "1,5" / "1.5" / "12" → Int milli-units (string/integer math, no floats). */
export function qtyToMilli(input: string): number {
  const normalized = input.replace(/\s/g, '').replace(',', '.');
  const match = /^(\d+)(?:\.(\d{1,3}))?$/.exec(normalized);
  if (!match) throw new Error(`Invalid quantity: "${input}"`);
  const [, whole, frac = ''] = match;
  const milli = Number(whole) * 1000 + Number(frac.padEnd(3, '0'));
  if (!Number.isSafeInteger(milli)) throw new Error(`Quantity out of range: "${input}"`);
  return milli;
}
